import { wallets as keplrWallets } from '@cosmos-kit/keplr';
import { wallets as cosmostationWallets } from '@cosmos-kit/cosmostation';
import { wallets as leapWallets } from '@cosmos-kit/leap';
import type { MainWalletBase } from '@cosmos-kit/core';

export function getSupportedWallets(): MainWalletBase[] {
  return [
    ...keplrWallets,
    ...cosmostationWallets,
    ...leapWallets,
  ];
}

export const WALLET_CONNECT_PROJECT_ID = 'fca94e1d68012104e4056b16caa374bd'; // To be configured

export interface WalletConfig {
  supportedWallets: MainWalletBase[];
  walletConnectProjectId: string;
}

export function getWalletConfig(): WalletConfig {
  return {
    supportedWallets: getSupportedWallets(),
    walletConnectProjectId: WALLET_CONNECT_PROJECT_ID,
  };
}
